module.exports = __webpack_public_path__ + "img/icons_25.86b8b91f.png";